<template>
  <div class="home-page cg-page">
    <!-- <Header></Header> -->
    <div class="pt20">
      <a class="logo" href="/"><img src="static/images/logo-new.png"/></a>
    </div>
    <div class="content">
      <div class="drop-down-content">
        <div class="login-content">
          <div class="ac fs33 pt20" style="width:80%;margin:30px auto 30px;color:#ffc497;text-transform: uppercase;"
               v-html="$t('cgtips1')"></div>
          <div class="ac" style="color:#ffc497;width:80%;margin:0 auto 40px;">{{ $t('cgtips2') }}</div>
          <div class="input-div">
            <div class="span fs33 fw7">{{ $t('phoneNumber') }}</div>
            <div class="input-item">
              <span>09</span>
              <input class="input" v-model="account" placeholder="">
            </div>
          </div>
          <div class="check">
            <div v-if="showWeekly"  class="item" :class="{ active: currentTab === 0 }" @click="switchTab(0)"><i></i>3 Days</div>
            <div v-if="showDaily" class="item" :class="{ active: currentTab === 1 }" @click="switchTab(1)"><i></i>Daily</div>
          </div>
          <div class="ac mt100">
            <button class="btn btn-blue" style="width:70%;" @click="status">{{ $t('Login') }}</button>
          </div>
          <div class="ac otp-b mt100">
            {{ $t('cgtips3') }}
            <router-link class="fs33 opt-a " :to="{path:'/TC'}">{{ $t('TC') }}</router-link>
            {{ $t('cgtips4') }}
          </div>
        </div>
      </div>
    </div>
    <Dialog ref="resub" :callback="goLogin" title="Reminder" :btnText="$t('subscribe')" :cancelText="$t('Login')">
      <div slot="mdBox" >
        <div class="">{{$t('re_sub_tip')}}</div>
      </div>
    </Dialog>

    <div class="resub buy-content" style="display: none;">
      <div class="model-bg"></div>
      <div class="model-content">
        <div class="un-t"></div>
        <div class="model-unsubscribe por ac">
          <div class="buy-tip" style="font-size: 40px;color: black">
            <div class="fs35 mt40 fw7">{{$t('re_sub_tip')}}</div>
          </div>
          <div class="button flex">
            <button @click="goLogin()" class="btn btn-cancel">{{$t('subscribe')}}</button>
            <button class="btn btn-blue sure-button" @click="login()">{{$t('Login')}}</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Header from '../components/headerNo'

import Dialog from '../components/dialog'

export default {
  components: {
    Dialog,
    Header
  },
  data() {
    return {
      list: [],
      account: '',
      currentTab: 0,
      type: 'weekly',
      password: '',
      showWeekly:true,
      showDaily:true,

    }
  },
  created() {
    let that = this
    if (this.$route.query.mobile) {
      that.account = that.dealPhone_2(that.$route.query.mobile)
    }
    let subappid = this.$route.query.subappid
    if (subappid == 'daily'){
      that.showWeekly = false
      that.showDaily = true
      that.type = 'daily'
      that.currentTab = 1
    }else if (subappid == 'weekly'){
      that.showWeekly = true
      that.showDaily = false
      that.type = 'weekly'
      that.currentTab = 0
    }

  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    switchTab(index) {
      this.currentTab = index;
      this.type = index === 1 ? "daily" : "weekly"
    },
    status(){
      let that = this;
      if (that.account === ""){
        that.$utils.alertText(that.$t('phone_error'), 80)
        return;
      }
      if (that.type === ""){
        that.$utils.alertText('ကျေးဇူးပြု၍ စာရင်းသွင်းမှု အမျိုးအစားကို ရွေးချယ်ပါ။', 80)
        return
      }
      let mobile = '09' + this.account
      mobile = this.dealPhone(mobile)
      let data = {
        mobile:mobile
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/user_status',data,r =>{
        that.$parent.loadModal(false);
        that.$parent.returnCode(r,function(){
          if (r.code == 0){
            that.$utils.alertText(r.msg,80);
          }else{
            if (r.data.status ==  3 && r.data.valid == 'Y'){
              $('.resub').show();
            }else{
              that.goLogin();
            }
          }
        })
      })
    },
    goLogin(reg = "reg"){
      let that = this;
      that.$parent.loadModal(true);
      if (that.account == '') {
        that.$utils.alertText(that.$t('phone_error'), 80)
        return;
      }
      let mobile = '09' + this.account
      mobile = this.dealPhone(mobile)

      //路由参数
      //路由参数
      let queryParams = Object.assign({}, this.$route.query);
      delete queryParams.subappid; // 删除 subappid

      const baseUrl = 'http://it.gameywar.com/gameywar/consent';
      const url = new URL(baseUrl);
      url.searchParams.append('mobile', mobile);
      url.searchParams.append('subappid', this.type);
      url.searchParams.append('reg', reg);

      Object.entries(queryParams).forEach(([key, value]) => {
        url.searchParams.append(key, value);
      });
      window.location.href = url.toString();
    },
    login(){
      let that = this;
      that.$parent.loadModal(true);
      if (that.account === ""){
        that.$utils.alertText(that.$t('phone_error'), 80)
        return
      }
      let mobile = '09' + this.account
      mobile = this.dealPhone(mobile)
      window.location.href = "https://gameywar.com/#/?mobile="+mobile;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    }

  }
}
</script>
<style scoped>

.model-bg{background: rgb(0 0 0 / 70%);width:100%;height: 100%;position: fixed;top: 0;bottom: 0;z-index: 100;}
.model-content{position:fixed;top:50%;left:50%;margin-top:-50%;background:#fff;border-radius:4px;margin-left: -40%;width: 80%;z-index: 101;border-radius: 40px;}
.model-unsubscribe{
  padding: 60px 40px 20px;
  /*background: url(/static/images/un-bg.png) no-repeat 0 0;*/
  width: 100%;
  height: auto;
  background-size: contain;
}
.button{justify-content: center;}
.btn-cancel,.btn-blue{background: #e2fcff;color:#00b6c8;font-size: 18px;border-radius: 5px;display: inline-block;width: 60%;margin: 20px 10px;font-weight:700;}
.btn-blue{background: #00b6c8;color:#fff;}

.drop-down-content {
  z-index: 9;
  background: none;
}

.input {
  background: #ffc497;
  height: 70px;
  border: none;
  border-radius: 20px;
  font-size: 38px;
  font-family: MyriadProBold;
  padding: 0 20px;
  width: 80%;
  color: #280933;
}

.input-div {
  margin: 30px 40px 10px;
}

.input-div .span {
  margin: 0 auto 10px;
  width: 70%;
}

.input-item {
  background: #ffc497;
  border-radius: 20px;
  height: 80px;
  line-height: 80px;
  width: 70%;
  margin: 0 auto;
}

.input-div div span {
  font-size: 38px;
  padding-left: 30px;
  color: #280933;
}

.mt100 {
  margin-top: 100px;
}

.opt-a {
  color: #2d31fa;
  text-decoration: underline;
}

.btn {
  line-height: 80px;
  background-color: #ffd024;
  width: 100%;
  color: #280933;
}

.cg-page {
  background: url(../../static/images/Background.png) no-repeat 0 0 #280933;
  color: #fff
}

.otp-b a {
  color: #fff
}

.check {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px
}

.check .item {
  display: flex;
  cursor: pointer;
  padding-left: 23px;
  align-items: center;
  width: 225px;
  margin: 0 15px;
  border-radius: 12px;
  font-size: 24px;
  line-height: 67px;
  background: #004F9E;
  color: #fff;
  text-align: center;
}

.check .item i {
  display: block;
  position: relative;
  margin-right: 12px;
  border: 2px solid #fff;
  width: 27px;
  height: 27px;
}

.check .active {
  background: #FF5353;
}

.check .active i:after {
  content: '✔';
  position: absolute;
  left: 0;
  top: -10px;
  font-size: 37px;
  line-height: 37px;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue